import { useStyles } from '../../../hooks/useStyles';
import CurrentStateList from '../../currentState/CurrentStateList';
import CurrentStateActionModals from '../../currentState/modal/CurrentStateActionModals';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';

function LivePage() {
  const { theme } = useStyles();

  return (
    <>
      <FloatingCardsLayout
        contentSize={1.54}
        content={
          <FloatingCardContent
            flexible
            gap={theme.sizing.scale600}
          >
            <CurrentStateList />
          </FloatingCardContent>
        }
      />
      <CurrentStateActionModals />
    </>
  );
}

export default LivePage;
